import { merge } from 'ramda';
import Utils from 'src/utils';
import { removeEventsFromPlannerState, replaceEventsInPlannerState } from 'src/store/reducers/tools/planner';
// eslint-disable-next-line import/no-cycle
import {
  BREAKS_FAIL, BREAKS_REQUEST, BREAKS_SUCCESS,
  EVENTS_FAIL, EVENTS_SUCCESS, EVENTS_REQUEST,
  SUBMIT_EVENT_FAIL, SUBMIT_EVENT_REQUEST, SUBMIT_EVENT_SUCCESS,
  EVENT_SUMMARY_REQUEST, EVENT_SUMMARY_SUCCESS, EVENT_SUMMARY_FAIL,
  EVENTS_UPDATE, SET_FORM_STATE,
  IMPORT_ABSENCES_FROM_AXAPTA_REQUEST, IMPORT_ABSENCES_FROM_AXAPTA_FAIL, IMPORT_ABSENCES_FROM_AXAPTA_SUCCESS,
  PLANNED_BY_JOBS_REQUEST, PLANNED_BY_JOBS_SUCCESS, PLANNED_BY_JOBS_FAIL,
  PLANNER_LAW_CHECK_REQUEST, PLANNER_LAW_CHECK_SUCCESS, PLANNER_LAW_CHECK_FAIL, PLANNER_LAW_CHECK_RESET,
  USER_PLANNING_CONFIRMATIONS_REQUEST, USER_PLANNING_CONFIRMATIONS_SUCCESS, USER_PLANNING_CONFIRMATIONS_FAIL,
  RELOAD_EVENTS_PART_SUCCESS,
  USER_PLANNING_CONFIRMATIONS_RESET, DELETE_EVENT_SUCCESS, EVENTS_UPDATE_MULTIPLE
} from 'src/store/actions/plannerActions';

const initialState = {
  formState: {},
  loadFetching: false,
  submitFetching: false,
  fetching: false,
  breaks: [],
  events: [],
  errors: [],
  summary: [],
  workDays: [],
  totalWorkingTime: '',
  summaryTotals: '',
  summaryFetching: false,
  currentDepartments: [],
  currentPeriod: '',
  axaptaAbsencesFetching: false,
  sendEmailFetching: false,
  plannedByJobs: {},
  plannedByJobsFetching: false,
  lawsCompliance: [],
  lawsComplianceFetching: false,
  userPlanningConfirmationsFetching: false,
  userPlanningConfirmations: []
};

const plannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case PLANNED_BY_JOBS_REQUEST:
      return merge(state, { plannedByJobsFetching: true });
    case PLANNED_BY_JOBS_SUCCESS:
      return merge(state, { plannedByJobsFetching: false, plannedByJobs: action.plannedByJobs });
    case PLANNED_BY_JOBS_FAIL:
      return merge(state, { plannedByJobsFetching: false });
    case SET_FORM_STATE:
      return merge(state, { formState: action.formState });
    case BREAKS_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case BREAKS_SUCCESS:
      return merge(state, { breaks: action.breaks, fetching: false, errors: [] });
    case BREAKS_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case IMPORT_ABSENCES_FROM_AXAPTA_REQUEST:
      return merge(state, { axaptaAbsencesFetching: true });
    case IMPORT_ABSENCES_FROM_AXAPTA_FAIL:
      return merge(state, { axaptaAbsencesFetching: false });
    case IMPORT_ABSENCES_FROM_AXAPTA_SUCCESS:
      return merge(state, { axaptaAbsencesFetching: false });
    case EVENTS_REQUEST:
      return merge(state, { loadFetching: true, errors: [] });
    case EVENTS_SUCCESS:
      return merge(state, {
        events: action.events,
        loadFetching: false,
        errors: [],
        currentDepartments: action.departmentIds,
        currentPeriod: action.period,
        workDays: action.workDays,
        totalWorkingTime: action.totalWorkingTime
      });
    case RELOAD_EVENTS_PART_SUCCESS:
      return merge(state, {
        events: Utils.arrays.mergeWithNestedObjectsMerge(state.events, action.events, 'User.UserId'),
        loadFetching: false,
        errors: []
      });
    case EVENTS_UPDATE:
      return merge(state, { events: action.events });
    case EVENTS_UPDATE_MULTIPLE:
      return merge(
        state,
        { events: replaceEventsInPlannerState(state.events, action.events) }
      );
    case EVENTS_FAIL:
      return merge(state, { loadFetching: false, errors: [action.error] });
    case SUBMIT_EVENT_REQUEST:
      return merge(state, { submitFetching: true, errors: [] });
    case SUBMIT_EVENT_SUCCESS:
      return merge(state, {
        submitFetching: false,
        errors: []
      });
    case SUBMIT_EVENT_FAIL:
      return merge(state, { submitFetching: false, errors: [action.error] });
    case EVENT_SUMMARY_REQUEST:
      return merge(state, { summaryFetching: true, summary: [], summaryTotals: '' });
    case EVENT_SUMMARY_SUCCESS:
      return merge(state, {
        summary: action.summary.JobWorkTimes, summaryTotals: action.summary.TotalWorkTime, summaryFetching: false, errors: []
      });
    case EVENT_SUMMARY_FAIL:
      return merge(state, {
        summaryFetching: false, summary: [], summaryTotals: '', errors: [action.error]
      });
    case PLANNER_LAW_CHECK_REQUEST:
      return ({ ...state, lawsComplianceFetching: true });
    case PLANNER_LAW_CHECK_SUCCESS:
      return ({ ...state, lawsComplianceFetching: false, lawsCompliance: action.payload });
    case PLANNER_LAW_CHECK_FAIL:
      return ({ ...state, lawsComplianceFetching: false });
    case PLANNER_LAW_CHECK_RESET:
      return ({ ...state, lawsCompliance: [] });
    case USER_PLANNING_CONFIRMATIONS_REQUEST:
      return merge(state, { userPlanningConfirmationsFetching: true });
    case USER_PLANNING_CONFIRMATIONS_SUCCESS:
      return merge(state, { userPlanningConfirmations: action.confirmations, userPlanningConfirmationsFetching: false });
    case USER_PLANNING_CONFIRMATIONS_FAIL:
      return merge(state, { userPlanningConfirmationsFetching: false });
    case USER_PLANNING_CONFIRMATIONS_RESET:
      return ({ ...state, userPlanningConfirmations: [] });
    case DELETE_EVENT_SUCCESS:
      return merge(state, { events: removeEventsFromPlannerState(state.events, action.ids) });
    default:
      return state;
  }
};

export default plannerReducer;
